module.exports = {
    ENV_URL_API: process.env.REACT_APP_ENV_URL_API || 'http://localhost:8002'
}
